import _ from 'lodash';
import moment from 'moment';
import DateTime from 'react-datetime';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
  Modal, ModalBody, ModalHeader, ModalFooter,
} from 'reactstrap';

import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';

import OutboundOrderHelpers from '../../../helpers/outboundOrder';
import ProductHelpers from '../../../helpers/products';
import cableCutHelpers from '../../../helpers/cableCut';

import addNotification from '../../../components/notification';
import UserConfirmationModal from '../../../components/pages/userConfirmationModal';

import Form from '../../../components/form/form';
import OneClickButton from '../../../components/form/button';

import { getPageLayout, updatePageLayout } from '../../../app/store/actions/pageLayout';
import { generateReport } from '../../../app/store/actions/reports';
import { cutsMonitoList } from '../../../app/store/actions/cutsMonito';

import cutsMonitoRequests from '../../../app/server/cutsMonito';

import {
  cancelOutboundOrder, cancelOutboundProduct, previewCancelOutboundProduct,
  getOutboundOrderListJustDocument,
  getOutboundOrderProducts, setOutboundOrdersProducts, deallocateOutboundOrder, deallocateOutboundProduct,
  cancelCrossdockingProduct, syncPickingConfirmationErp, confirmPreExpedition,
} from '../../../app/store/actions/outboundOrders';
import FormatHelpers from '../../../helpers/format';
import WikiHelp from '../../../components/tooltip/wikiHelp';
import { toggleOrderPriority } from '../../../app/store/actions/outboundMonitor';
import { getBranchesOptions } from '../../../app/store/actions/branches';
import Permissions from '../../../app/services/permissions';
import PrintFractionalPackagingLabel from '../../../components/printLabel/fractionalPackaging';

class OutboundOrderList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      cancelType: '',
      deallocateType: '',
      showCancelModal: false,
      showCancelProductModal: false,
      showDeallocateModal: false,
      showDeallocateProductModal: false,
      showPrintFractionalPackagingLabelModal: false,
      showCancelCrossdockingProductModal: false,
      showOriginSelectionModal: false,
      cancelOrigins: [],
      selectedCancelOriginIds: [],
      cancelOriginChecked: {},
      cancelOriginTotalSelected: 0,
      showSyncPickingConfirmationModal: false,
      selectedOutboundOrder: {},
      selectedOutboundProduct: null,
      showUserModal: false,
      showModalUrgent: false,
      outboundOrderUrgent: null,
      defaultSortedProducts: [{
        id: 'lineNumber',
        desc: false,
      }],
      defaultSorted: [{
        id: 'orderNumber',
        desc: false,
      }],
      defaultSortedCableCut: [],
      showModalNote: false,
      note: '',
      showPreExpeditionModal: false,
      withdrawalUser: '',
      withdrawalAt: null,
      withdrawnUserDocument: '',
      withdrawnNote: '',
      showModalPageLayout: false,
      pageLayout: {
        showLoadNumber: true,
        showTotalWeight: true,
        showCustomerOrderCode: true,
        showCustomer: true,
        showOrderType: true,
        showDeposit: true,
        showInvoiceNumber: true,
        showStatus: true,
        showUrgent: true,
        showPriority: true,
        showCarrier: true,
        showCity: true,
        showDeliveryDate: true,
        showCreatedAt: true,
        showDockControl: true,
        showWaybillNumber: true,
        showRestrictionPicking: true,
        showUserReleasePickingRestriction: true,
        showReleasePickingRestriction: true,
        showWithdrawalUser: true,
        showWithdrawalAt: true,
        showWithdrawalUserDocument: true,
        showWithdrawnNote: true,
        showProductDescription: true,
        showProductStatus: true,
        showProductQuantity: true,
        showProductCrossDockingQuantity: true,
        showProductMandatoryQuantity: true,
        showProductControlExpirationDate: true,
        showProductStockControlType: true,
        showProductAllocatedQuantity: true,
        showProductPickedQuantity: true,
        showProductPickedAt: true,
        showProductPickedUser: true,
        showProductCheckedQuantity: true,
        showProductCheckedAt: true,
        showProductCheckedUser: true,
        showProductCustomerProductCode: true,
        showProductComplementCode: true,
      },
      tableColumns: [],
      productTableColumns: [],
      cableCutProductTableColumns: [],
      hasCableCut: false,
      cableCutList: [],
      showLoadNumber: true,
      showTotalWeight: true,
      showCustomerOrderCode: true,
      showCustomer: true,
      showOrderType: true,
      showDeposit: true,
      showInvoiceNumber: true,
      showStatus: true,
      showUrgent: true,
      showPriority: true,
      showCarrier: true,
      showCity: true,
      showDeliveryDate: true,
      showCreatedAt: true,
      showDockControl: true,
      showWaybillNumber: true,
      showRestrictionPicking: true,
      showUserReleasePickingRestriction: true,
      showReleasePickingRestriction: true,
      showWithdrawalUser: true,
      showWithdrawalAt: true,
      showWithdrawalUserDocument: true,
      showWithdrawnNote: true,
      showProductDescription: true,
      showProductStatus: true,
      showProductQuantity: true,
      showProductCrossDockingQuantity: true,
      showProductMandatoryQuantity: true,
      showProductControlExpirationDate: true,
      showProductStockControlType: true,
      showProductAllocatedQuantity: true,
      showProductPickedQuantity: true,
      showProductPickedAt: true,
      showProductPickedUser: true,
      showProductCheckedQuantity: true,
      showProductCheckedAt: true,
      showProductCheckedUser: true,
      showProductCustomerProductCode: true,
      showProductComplementCode: true,
    };
  }

  async componentDidMount() {
    this.getOutboundOrders();
    await this.getPageLayout();
    this.updateColumns();
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.userLogged && this.props.userLogged) {
      await this.getPageLayout();
      this.updateColumns();
    }
  }

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  showUrgentModal = (outboundOrderId) => {
    this.setState({
      showModalUrgent: true,
      outboundOrderUrgent: outboundOrderId,
    });
  };

  closeUrgentModal = () => {
    this.setState({
      showModalUrgent: false,
      showRemoveUrgent: false,
      outboundOrderUrgent: null,
    });
  };

  showModalRemoveUrgent = async (outboundOrderId) => {
    this.setState({
      showRemoveUrgent: true,
      outboundOrderUrgent: outboundOrderId,
    });
  };

  showPageLayoutModal = () => {
    this.setState({
      showModalPageLayout: true,
    });
  };

  closePageLayoutModal = () => {
    this.getPageLayout();
    this.setState({
      showModalPageLayout: false,
    });
  };

  getTableColumns = () => {
    const { pageLayout = {} } = this.state;

    return [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => {
          const outboundRange = rows.original;
          const showCancel = this.props.isConsult
            ? false
            : !!(rows.original.status < 4 && !rows.original.pickStartAt);

          let showDeallocate = false;
          let showPrintFractionalPackagingLabel = false;

          if (!this.props.isConsult) {
            if (
              (!outboundRange.depositCode && rows.original.status > 1)
              || (outboundRange.depositCode && rows.original.status >= 1)
            ) {
              showDeallocate = rows.original.status < 4 && !rows.original.pickStartAt;
            }
          }

          if (rows.original.isPrintFractionalPackagingLabel && rows.original.status < 10) {
            showPrintFractionalPackagingLabel = true;
          }

          return (
            <div style={{ textAlign: 'center' }}>
              <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
              <UncontrolledButtonDropdown>
                <DropdownToggle color="default" caret className="btn-xs" />
                <DropdownMenu positionFixed="true" style={{ zIndex: 1 }}>
                  {![9, 10, 12, 13].includes(outboundRange.status) && (
                    !outboundRange.urgent ? (
                      <DropdownItem onClick={() => this.showUrgentModal(outboundRange.id)}>
                        {I18n.t('BEE613' /* Urgente */)}
                      </DropdownItem>
                    ) : (
                      <DropdownItem onClick={() => this.showModalRemoveUrgent(outboundRange.id)}>
                        {I18n.t('BEE2637' /* Remover Urgência */)}
                      </DropdownItem>
                    )
                  )}
                  <DropdownItem onClick={() => this.showOutboundOrderDetail(rows)}>
                    {I18n.t('BEE56' /* Detalhes */)}
                  </DropdownItem>
                  {showDeallocate && (
                    <DropdownItem onClick={() => this.showDeallocateOrder(rows.original)}>
                      {I18n.t('BEE3278' /* Desalocar */)}
                    </DropdownItem>
                  )}
                  {showPrintFractionalPackagingLabel && (
                    <DropdownItem
                      onClick={() => this.showPrintFractionalPackagingLabel(rows.original)}
                    >
                      {I18n.t('BEE4195' /* Imprimir Etiqueta */)}
                    </DropdownItem>
                  )}
                  {rows.original.isPrintSalesOrderPdf && (
                    <DropdownItem
                      onClick={() => this.onGenerateSalesOrderPDF(rows.original)}
                    >
                      {I18n.t('BEE4550' /* Gerar PDF para o Pedido de Venda (Saída) */)}
                    </DropdownItem>
                  )}
                  {(rows.original.status === 6 || rows.original.status === 13)
                    && rows.original.isManualConfirmPicking
                    && !(rows.original.integrated || rows.original.invoiceNumber) && (
                      <DropdownItem
                        onClick={() => this.showSyncPickingConfirmation(rows.original)}
                      >
                        {I18n.t('BEE4569' /* Liberar o faturamento */)}
                      </DropdownItem>
                  )}
                  {(!Permissions.checkPermission(ROUTES.P_EXPEDITION_CANCEL_ORDER)
                    && showCancel && (
                      <DropdownItem onClick={() => this.showCancelOrder(rows.original)}>
                        {I18n.t('BEE99' /* Cancelar */)}
                      </DropdownItem>
                  ))}
                  {(!this.props.isConsult && rows.original.isPreShipment && rows.original.status < 6) && (
                    <DropdownItem onClick={() => this.showPreExpeditionModal(rows.original)}>
                      {I18n.t('BEE4578' /* Pré-Expedição */)}
                    </DropdownItem>
                  )}
                  <DropdownItem onClick={() => {
                    this.setState({
                      showModalNote: true,
                      note: rows.original.note,
                    });
                  }}
                  >
                    {I18n.t('BEE135' /* Observação */)}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          );
        },
      }, {
        Header: I18n.t('BEE443' /* Documento */),
        accessor: 'orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: true,
      }, {
        Header: I18n.t('BEE4526' /* Carga */),
        accessor: 'loadNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showLoadNumber'),
      }, {
        Header: I18n.t('BEE4488' /* Peso (kg) */),
        accessor: 'totalWeight',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showTotalWeight'),
        Cell: (row) => {
          const weightKG = parseFloat(row.value || 0) === 0 ? 0 : FormatHelpers.formatNumber(row.value / 1000, 4);
          return <span>{weightKG}</span>;
        },
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
        show: true,
      }, {
        Header: I18n.t('BEE1096' /* Pedido cliente */),
        accessor: 'customerOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showCustomerOrderCode'),
      }, {
        Header: I18n.t('BEE50' /* Cliente */),
        accessor: 'customerName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showCustomer'),
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showOrderType'),
      }, {
        Header: I18n.t('BEE182' /* Depósito */),
        accessor: 'depositCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showDeposit'),
      }, {
        Header: I18n.t('BEE402' /* Nota Fiscal */),
        accessor: 'invoiceNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showInvoiceNumber'),
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        show: this.showColumn(pageLayout, 'showStatus'),
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <span>{OutboundOrderHelpers.outboundOrderStatus(row.value)}</span>
          </div>
        ),
        filterMethod: (filter, row) => {
          if (parseInt(filter.value, 10) === parseInt(row.status, 10)) {
            return true;
          }
        },
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {OutboundOrderHelpers.outboundOrderStatus().map((elem, index) => (
              <option value={elem.value} key={index}>{elem.label}</option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE613' /* Urgente */),
        accessor: 'urgent',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showUrgent'),
        Cell: (rows) => (
          <div className={{ textAlign: 'center' }}>
            {rows.original.urgent ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
          </div>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            <option value>{I18n.t('BEE172' /* Sim */)}</option>
            <option value={false}>{I18n.t('BEE173' /* Não */)}</option>
          </select>
        ),
      }, {
        Header: I18n.t('BEE4115' /* Prioridade */),
        accessor: 'priorityName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showPriority'),
      }, {
        Header: I18n.t('BEE301' /* Transportadora */),
        accessor: 'carrierName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showCarrier'),
      }, {
        Header: I18n.t('BEE53' /* Cidade */),
        accessor: 'cityName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showCity'),
      }, {
        Header: I18n.t('BEE1057' /* Entrega */),
        accessor: 'deliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {moment(row.value).format('DD/MM/YYYY')}
          </span>
        ),
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showDeliveryDate'),
      }, {
        Header: I18n.t('BEE513' /* Integração */),
        accessor: 'createdAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {moment(row.value).format('L LTS')}
          </span>
        ),
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showCreatedAt'),
      }, {
        Header: I18n.t('BEE3197' /* Controle da doca */),
        accessor: 'dockControlId',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showDockControl'),
      }, {
        Header: I18n.t('BEE907' /* Romaneio */),
        accessor: 'waybillNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showWaybillNumber'),
      }, {
        Header: I18n.t('BEE2779' /* Restrição Liberada */),
        accessor: 'restrictionPicking',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showRestrictionPicking'),
        Cell: (rows) => (
          <div>
            <span>
              {(!rows.original.restrictionPicking)
                ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
            </span>
          </div>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            <option value={false}>{I18n.t('BEE172' /* Sim */)}</option>
            <option value>{I18n.t('BEE173' /* Não */)}</option>
          </select>
        ),
      }, {
        Header: I18n.t('BEE2780' /* Usuário Liberação */),
        accessor: 'userReleasePickingRestriction.login',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showUserReleasePickingRestriction'),
        Cell: (rows) => (
          <div className={{ textAlign: 'center' }}>
            {rows.original.userReleasePickingRestriction ? rows.original.userReleasePickingRestriction.login : ''}
          </div>
        ),
      }, {
        Header: I18n.t('BEE2781' /* Data e Hora liberação */),
        accessor: 'releasePickingRestriction',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.original.releasePickingRestriction
              ? moment(row.releasePickingRestriction).format('L LTS')
              : ''}
          </span>
        ),
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showReleasePickingRestriction'),
      },
      {
        Header: I18n.t('BEE3690' /* Retirado por */),
        accessor: 'withdrawalUser',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showWithdrawalUser'),
      },
      {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'withdrawalAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {row.value ? moment(row.value).format('DD/MM/YYYY') : ''}
          </span>
        ),
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showWithdrawalAt'),
      },
      {
        Header: I18n.t('BEE3691' /* Documento do Recebedor */),
        accessor: 'withdrawnUserDocument',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showWithdrawalUserDocument'),
      },
      {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'withdrawnNote',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showWithdrawnNote'),
      },
    ];
  };

  getProductTableColumns = () => {
    const { pageLayout = {} } = this.state;

    return [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => {
          let showDeallocate = false;
          let showPrintFractionalPackagingLabel = false;

          const row = rows.original;

          if (this.props.isConsult) {
            showDeallocate = false;
          } else if (row.isProductionSeparation) {
            showDeallocate = row.status >= 1 && row.status < 5
              && (parseFloat(row.allocatedQuantity || 0) - parseFloat(row.pickedQuantity || 0) > 0);
          } else {
            showDeallocate = !!(row.status > 1 && row.status < 5 && !row.pickedQuantity);
          }
          if (row.isPrintFractionalPackagingLabel && row.status < 7) {
            showPrintFractionalPackagingLabel = true;
          }

          return (
            <div style={{ textAlign: 'center' }}>
              <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
              <UncontrolledButtonDropdown>
                <DropdownToggle color="default" caret className="btn-xs" />
                <DropdownMenu>
                  {!Permissions.checkPermission(ROUTES.P_EXPEDITION_CANCEL_ITEM_ORDER)
                    && !this.props.isConsult && row.status < 5
                    && (
                      <DropdownItem
                        onClick={() => this.showCancelProduct(row)}
                      >
                        {I18n.t('BEE99' /* Cancelar */)}
                      </DropdownItem>
                    )}
                  {showDeallocate
                    && (
                      <DropdownItem
                        onClick={() => this.showDeallocateProduct(row)}
                      >
                        {I18n.t('BEE3278' /* Desalocar */)}
                      </DropdownItem>
                    )}
                  {showPrintFractionalPackagingLabel
                    && (
                      <DropdownItem
                        onClick={() => this.showPrintFractionalPackagingLabel(false, row)}
                      >
                        {I18n.t('BEE4195' /* Imprimir Etiqueta */)}
                      </DropdownItem>
                    )}
                  {!Permissions.checkPermission(ROUTES.P_EXPEDITION_CANCEL_PRODUCT_CROSSDOCKING)
                    && row.status === 1 && row.crossdockingQuantity > 0
                    && (
                      <DropdownItem
                        onClick={() => this.showCancelCrossdockingProduct(row)}
                      >
                        {I18n.t('BEE4378' /* Cancelar Cross-Docking */)}
                      </DropdownItem>
                    )}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          );
        },
      }, {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        show: true,
      }, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: true,
      }, {
        Header: I18n.t('BEE695' /* Código Complementar */),
        accessor: 'productComplementCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        show: this.showColumn(pageLayout, 'showProductComplementCode'),
      }, {
        Header: I18n.t('BEE1897' /* Descrição */),
        accessor: 'productName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
        show: this.showColumn(pageLayout, 'showProductDescription'),
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        show: this.showColumn(pageLayout, 'showProductStatus'),
        Cell: (row) => (
          <span>{OutboundOrderHelpers.outboundOrderProductStatus(row.value)}</span>
        ),
        filterMethod: (filter, row) => {
          if (parseInt(filter.value, 10) === parseInt(row.status, 10)) {
            return true;
          }
        },
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%', textAlign: 'center' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {OutboundOrderHelpers.outboundOrderProductStatus().map((elem, index) => (
              <option value={elem.value} key={index}>{elem.label}</option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductQuantity'),
        type: 'number',
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE4377' /* Quantidade Cross-Docking */),
        accessor: 'crossdockingQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductCrossDockingQuantity'),
        type: 'number',
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE1579' /* Lance Obrigatório */),
        accessor: 'mandatoryQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductMandatoryQuantity'),
        type: 'number',
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE701' /* Controlar Vencimento */),
        accessor: 'controlExpirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        show: this.showColumn(pageLayout, 'showProductControlExpirationDate'),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option key="all" value="">{I18n.t('BEE793' /* Todos */)}</option>
            <option key="true" value>{I18n.t('BEE172' /* Sim */)}</option>
            <option key="false" value={false}>{I18n.t('BEE173' /* Não */)}</option>
          </select>
        ),
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <span>{row.value ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}</span>
          </div>
        ),
      }, {
        Header: I18n.t('BEE708' /* Tipo de Controle de Estoque */),
        accessor: 'stockControlType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        show: this.showColumn(pageLayout, 'showProductStockControlType'),
        Cell: (row) => (
          <span>{ProductHelpers.stockControlType(row.value)}</span>
        ),
        filterMethod: (filter, row) => {
          if (parseInt(filter.value, 10) === parseInt(row.stockControlType, 10)) {
            return true;
          }
        },
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {ProductHelpers.stockControlType().map((element, index) => (
              <option key={index} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE1431' /* Alocado */),
        accessor: 'allocatedQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductAllocatedQuantity'),
        type: 'number',
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE1368' /* Separado */),
        accessor: 'pickedQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductPickedQuantity'),
        type: 'number',
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE1721' /* Data Separação */),
        accessor: 'pickedAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductPickedAt'),
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE1092' /* Separador */),
        accessor: 'pickedUser',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductPickedUser'),
      }, {
        Header: I18n.t('BEE445' /* Conferido */),
        accessor: 'checkedQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductCheckedQuantity'),
        type: 'number',
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE467' /* Data Conferência */),
        accessor: 'checkedAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductCheckedAt'),
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE805' /* Conferente */),
        accessor: 'checkedUser',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        show: this.showColumn(pageLayout, 'showProductCheckedUser'),
      }, {
        Header: I18n.t('BEE2112' /* Produto Cliente */),
        accessor: 'customerProductCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        show: this.showColumn(pageLayout, 'showProductCustomerProductCode'),
      },
    ];
  };

  getCableCutProductTableColumns = () => [
    {
      Header: I18n.t('BEE1581' /* Corte */),
      accessor: 'code',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 80,
    },
    {
      Header: I18n.t('BEE626' /* Prioridades */),
      accessor: 'priorityCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE1378' /* Documento */),
      accessor: 'orderNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
    },
    {
      Header: I18n.t('BEE50' /* Cliente */),
      accessor: 'customerName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
    },
    {
      Header: I18n.t('BEE1688' /* Quantidade */),
      accessor: 'quantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    },
    {
      Header: I18n.t('BEE428' /* Lote */),
      accessor: 'lotNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE225' /* Produto */),
      accessor: 'productName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 250,
    },
    {
      Header: I18n.t('BEE1808' /* Pedido Cliente */),
      accessor: 'customerOrderCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE463' /* Linha */),
      accessor: 'lineNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE1829' /* Minimo */),
      accessor: 'minimumQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    },
    {
      Header: I18n.t('BEE1114' /* Obrigatório */),
      accessor: 'mandatoryQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    },
    {
      Header: I18n.t('BEE204' /* Situação */),
      accessor: 'status',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <span>{cableCutHelpers.cableCutStatus(row.value)}</span>
        </div>
      ),
      filterMethod: (filter, row) => {
        if (parseInt(filter.value) === parseInt(row.status)) {
          return true;
        }
      },
      Filter: ({ filter, onChange }) => (
        <select
          type="text"
          style={{ width: '100%' }}
          onChange={(event) => {
            onChange(event.target.value);
          }}
        >
          <option value="" key="all">
            {I18n.t('BEE793' /* Todos */)}
          </option>
          {cableCutHelpers.cableCutStatus().map((elem, index) => (
            <option value={elem.value} key={index}>
              {elem.label}
            </option>
          ))}
        </select>
      ),
    },
    {
      Header: I18n.t('BEE578' /* Data de Criação */),
      accessor: 'createdAt',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE575' /* Usuário de Criação */),
      accessor: 'createdUser',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 130,
    },
    {
      Header: I18n.t('BEE1850' /* Data de Corte */),
      accessor: 'finishCableCutAt',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE1851' /* Usuário Corte */),
      accessor: 'finishCableCutUser',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
    {
      Header: I18n.t('BEE34' /* Transferência */),
      accessor: 'transferOrderCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    },
  ];

  updateColumns = () => {
    const newTableColumns = this.getTableColumns();
    const newProductTableColumns = this.getProductTableColumns();
    const newCableCutProductTableColumns = this.getCableCutProductTableColumns();
    this.setState({
      tableColumns: newTableColumns,
      productTableColumns: newProductTableColumns,
      cableCutProductTableColumns: newCableCutProductTableColumns,
    });
  };

  getPageLayout = async () => {
    const { userLogged } = this.props;

    if (userLogged && userLogged.mainBranchData) {
      const { mainBranchData } = userLogged;

      const layoutSelected = await this.props.getPageLayout({
        branchCode: mainBranchData.code,
        page: this.props.location.pathname,
      });

      if (layoutSelected && layoutSelected.layout) {
        this.setState({
          pageLayout: {
            ...layoutSelected.layout,
            showTotalWeight: layoutSelected.layout.showTotalWeight ?? true,
          },
          showLoadNumber: layoutSelected.layout.showLoadNumber,
          showTotalWeight: layoutSelected.layout.showTotalWeight ?? true,
          showCustomerOrderCode: layoutSelected.layout.showCustomerOrderCode,
          showCustomer: layoutSelected.layout.showCustomer,
          showOrderType: layoutSelected.layout.showOrderType,
          showDeposit: layoutSelected.layout.showDeposit,
          showInvoiceNumber: layoutSelected.layout.showInvoiceNumber,
          showStatus: layoutSelected.layout.showStatus,
          showUrgent: layoutSelected.layout.showUrgent,
          showPriority: layoutSelected.layout.showPriority,
          showCarrier: layoutSelected.layout.showCarrier,
          showCity: layoutSelected.layout.showCity,
          showDeliveryDate: layoutSelected.layout.showDeliveryDate,
          showCreatedAt: layoutSelected.layout.showCreatedAt,
          showDockControl: layoutSelected.layout.showDockControl,
          showWaybillNumber: layoutSelected.layout.showWaybillNumber,
          showRestrictionPicking: layoutSelected.layout.showRestrictionPicking,
          showUserReleasePickingRestriction: layoutSelected.layout.showUserReleasePickingRestriction,
          showReleasePickingRestriction: layoutSelected.layout.showReleasePickingRestriction,
          showWithdrawalUser: layoutSelected.layout.showWithdrawalUser,
          showWithdrawalAt: layoutSelected.layout.showWithdrawalAt,
          showWithdrawalUserDocument: layoutSelected.layout.showWithdrawalUserDocument,
          showWithdrawnNote: layoutSelected.layout.showWithdrawnNote,
          showProductDescription: layoutSelected.layout.showProductDescription,
          showProductStatus: layoutSelected.layout.showProductStatus,
          showProductQuantity: layoutSelected.layout.showProductQuantity,
          showProductCrossDockingQuantity: layoutSelected.layout.showProductCrossDockingQuantity,
          showProductMandatoryQuantity: layoutSelected.layout.showProductMandatoryQuantity,
          showProductControlExpirationDate: layoutSelected.layout.showProductControlExpirationDate,
          showProductStockControlType: layoutSelected.layout.showProductStockControlType,
          showProductAllocatedQuantity: layoutSelected.layout.showProductAllocatedQuantity,
          showProductPickedQuantity: layoutSelected.layout.showProductPickedQuantity,
          showProductPickedAt: layoutSelected.layout.showProductPickedAt,
          showProductPickedUser: layoutSelected.layout.showProductPickedUser,
          showProductCheckedQuantity: layoutSelected.layout.showProductCheckedQuantity,
          showProductCheckedAt: layoutSelected.layout.showProductCheckedAt,
          showProductCheckedUser: layoutSelected.layout.showProductCheckedUser,
          showProductCustomerProductCode: layoutSelected.layout.showProductCustomerProductCode,
          showProductComplementCode: layoutSelected.layout.showProductComplementCode,
        });
      }
    }
  };

  updatePageLayoutArray = () => {
    const {
      showLoadNumber, showCustomerOrderCode, showCustomer, showOrderType, showDeposit, showInvoiceNumber,
      showStatus, showUrgent, showPriority, showCarrier, showCity, showDeliveryDate, showCreatedAt, showDockControl,
      showWaybillNumber, showRestrictionPicking, showUserReleasePickingRestriction, showReleasePickingRestriction,
      showWithdrawalUser, showWithdrawalAt, showWithdrawalUserDocument, showWithdrawnNote, showProductDescription,
      showProductStatus, showProductQuantity, showProductCrossDockingQuantity, showProductMandatoryQuantity,
      showProductControlExpirationDate, showProductStockControlType, showProductAllocatedQuantity,
      showProductPickedQuantity, showProductPickedAt, showProductPickedUser, showProductCheckedQuantity,
      showProductCheckedAt, showProductCheckedUser, showProductCustomerProductCode, showTotalWeight,
      showProductComplementCode,
    } = this.state;

    const layout = {
      showLoadNumber,
      showTotalWeight,
      showCustomerOrderCode,
      showCustomer,
      showOrderType,
      showDeposit,
      showInvoiceNumber,
      showStatus,
      showUrgent,
      showPriority,
      showCarrier,
      showCity,
      showDeliveryDate,
      showCreatedAt,
      showDockControl,
      showWaybillNumber,
      showRestrictionPicking,
      showUserReleasePickingRestriction,
      showReleasePickingRestriction,
      showWithdrawalUser,
      showWithdrawalAt,
      showWithdrawalUserDocument,
      showWithdrawnNote,
      showProductDescription,
      showProductStatus,
      showProductQuantity,
      showProductCrossDockingQuantity,
      showProductMandatoryQuantity,
      showProductControlExpirationDate,
      showProductStockControlType,
      showProductAllocatedQuantity,
      showProductPickedQuantity,
      showProductPickedAt,
      showProductPickedUser,
      showProductCheckedQuantity,
      showProductCheckedAt,
      showProductCheckedUser,
      showProductCustomerProductCode,
      showProductComplementCode,
    };

    try {
      const { userLogged } = this.props;

      if (userLogged && userLogged.mainBranchData) {
        const { mainBranchData } = userLogged;

        const updLayout = this.props.updatePageLayout({
          branchCode: mainBranchData.code,
          page: this.props.location.pathname,
          layout,
        });

        if (updLayout) {
          addNotification(
            'success',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4442' /* Atualização do Layout de Página efetuada com sucesso! */),
            'top-right',
          );

          this.setState({
            pageLayout: layout,
          });
          this.updateColumns();
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            `${error.code} - ${error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
      }
    }
    this.setState({
      showModalPageLayout: false,
    });
  };

  createPageLayoutModal = () => {
    const {
      showModalPageLayout, showCustomerOrderCode, showCustomer, showOrderType, showDeposit, showInvoiceNumber,
      showStatus, showUrgent, showPriority, showCarrier, showCity, showDeliveryDate, showCreatedAt, showDockControl,
      showWaybillNumber, showRestrictionPicking, showUserReleasePickingRestriction, showReleasePickingRestriction,
      showWithdrawalUser, showWithdrawalAt, showWithdrawalUserDocument, showWithdrawnNote, showProductDescription,
      showProductStatus, showProductQuantity, showProductCrossDockingQuantity, showProductMandatoryQuantity,
      showProductControlExpirationDate, showProductStockControlType, showProductAllocatedQuantity,
      showProductPickedQuantity, showProductPickedAt, showProductPickedUser, showProductCheckedQuantity,
      showProductCheckedAt, showProductCheckedUser, showProductCustomerProductCode, showLoadNumber, showTotalWeight,
      showProductComplementCode,
    } = this.state;

    return (
      <Modal
        size="md"
        isOpen={showModalPageLayout}
        toggle={() => this.closePageLayoutModal()}
      >
        <ModalHeader toggle={() => this.closePageLayoutModal()}>
          <span className="text-center">
            {I18n.t('BEE4439' /* Gerenciar Colunas */).toLocaleUpperCase()}
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12 text-right">
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE1378' /* Documento */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showLoadNumber,
                    'showLoadNumber',
                    I18n.t('BEE4526' /* Carga */),
                  ),
                  formContext.createToggleBox(
                    showTotalWeight,
                    'showTotalWeight',
                    I18n.t('BEE4488' /* Peso (kg) */),
                  ),
                  formContext.createToggleBox(
                    showCustomerOrderCode,
                    'showCustomerOrderCode',
                    I18n.t('BEE1096' /* Pedido cliente */),
                  ),
                  formContext.createToggleBox(
                    showCustomer,
                    'showCustomer',
                    I18n.t('BEE50' /* Cliente */),
                  ),
                  formContext.createToggleBox(
                    showOrderType,
                    'showOrderType',
                    I18n.t('BEE200' /* Tipo */),
                  ),
                  formContext.createToggleBox(
                    showDeposit,
                    'showDeposit',
                    I18n.t('BEE182' /* Depósito */),
                  ),
                  formContext.createToggleBox(
                    showInvoiceNumber,
                    'showInvoiceNumber',
                    I18n.t('BEE402' /* Nota Fiscal */),
                  ),
                  formContext.createToggleBox(
                    showStatus,
                    'showStatus',
                    I18n.t('BEE224' /* Status */),
                  ),
                  formContext.createToggleBox(
                    showUrgent,
                    'showUrgent',
                    I18n.t('BEE613' /* Urgente */),
                  ),
                  formContext.createToggleBox(
                    showPriority,
                    'showPriority',
                    I18n.t('BEE4115' /* Prioridade */),
                  ),
                  formContext.createToggleBox(
                    showCarrier,
                    'showCarrier',
                    I18n.t('BEE301' /* Transportadora */),
                  ),
                  formContext.createToggleBox(
                    showCity,
                    'showCity',
                    I18n.t('BEE53' /* Cidade */),
                  ),
                  formContext.createToggleBox(
                    showDeliveryDate,
                    'showDeliveryDate',
                    I18n.t('BEE1057' /* Entrega */),
                  ),
                  formContext.createToggleBox(
                    showCreatedAt,
                    'showCreatedAt',
                    I18n.t('BEE513' /* Integração */),
                  ),
                  formContext.createToggleBox(
                    showDockControl,
                    'showDockControl',
                    I18n.t('BEE3197' /* Controle da doca */),
                  ),
                  formContext.createToggleBox(
                    showWaybillNumber,
                    'showWaybillNumber',
                    I18n.t('BEE907' /* Romaneio */),
                  ),
                  formContext.createToggleBox(
                    showRestrictionPicking,
                    'showRestrictionPicking',
                    I18n.t('BEE2779' /* Restrição Liberada */),
                  ),
                  formContext.createToggleBox(
                    showUserReleasePickingRestriction,
                    'showUserReleasePickingRestriction',
                    I18n.t('BEE2780' /* Usuário Liberação */),
                  ),
                  formContext.createToggleBox(
                    showReleasePickingRestriction,
                    'showReleasePickingRestriction',
                    I18n.t('BEE2781' /* Data e Hora liberação */),
                  ),
                  formContext.createToggleBox(
                    showWithdrawalUser,
                    'showWithdrawalUser',
                    I18n.t('BEE3690' /* Retirado por */),
                  ),
                  formContext.createToggleBox(
                    showWithdrawalAt,
                    'showWithdrawalAt',
                    I18n.t('BEE444' /* Data de Entrega */),
                  ),
                  formContext.createToggleBox(
                    showWithdrawalUserDocument,
                    'showWithdrawalUserDocument',
                    I18n.t('BEE3691' /* Documento do Recebedor */),
                  ),
                  formContext.createToggleBox(
                    showWithdrawnNote,
                    'showWithdrawnNote',
                    I18n.t('BEE135' /* Observação */),
                  ),
                ])}
              />
            </div>
            <hr />
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE27' /* Produtos */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showProductComplementCode,
                    'showProductComplementCode',
                    I18n.t('BEE695' /* Código Complementar */),
                  ),
                  formContext.createToggleBox(
                    showProductDescription,
                    'showProductDescription',
                    I18n.t('BEE1897' /* Descrição */),
                  ),
                  formContext.createToggleBox(
                    showProductStatus,
                    'showProductStatus',
                    I18n.t('BEE224' /* Status */),
                  ),
                  formContext.createToggleBox(
                    showProductQuantity,
                    'showProductQuantity',
                    I18n.t('BEE441' /* Quantidade */),
                  ),
                  formContext.createToggleBox(
                    showProductCrossDockingQuantity,
                    'showProductCrossDockingQuantity',
                    I18n.t('BEE4377' /* Quantidade Cross-Docking */),
                  ),
                  formContext.createToggleBox(
                    showProductMandatoryQuantity,
                    'showProductMandatoryQuantity',
                    I18n.t('BEE1579' /* Lance Obrigatório */),
                  ),
                  formContext.createToggleBox(
                    showProductControlExpirationDate,
                    'showProductControlExpirationDate',
                    I18n.t('BEE701' /* Controlar Vencimento */),
                  ),
                  formContext.createToggleBox(
                    showProductStockControlType,
                    'showProductStockControlType',
                    I18n.t('BEE708' /* Tipo de Controle de Estoque */),
                  ),
                  formContext.createToggleBox(
                    showProductAllocatedQuantity,
                    'showProductAllocatedQuantity',
                    I18n.t('BEE1431' /* Alocado */),
                  ),
                  formContext.createToggleBox(
                    showProductPickedQuantity,
                    'showProductPickedQuantity',
                    I18n.t('BEE1368' /* Separado */),
                  ),
                  formContext.createToggleBox(
                    showProductPickedAt,
                    'showProductPickedAt',
                    I18n.t('BEE1721' /* Data Separação */),
                  ),
                  formContext.createToggleBox(
                    showProductPickedUser,
                    'showProductPickedUser',
                    I18n.t('BEE1092' /* Separador */),
                  ),
                  formContext.createToggleBox(
                    showProductCheckedQuantity,
                    'showProductCheckedQuantity',
                    I18n.t('BEE445' /* Conferido */),
                  ),
                  formContext.createToggleBox(
                    showProductCheckedAt,
                    'showProductCheckedAt',
                    I18n.t('BEE467' /* Data Conferência */),
                  ),
                  formContext.createToggleBox(
                    showProductCheckedUser,
                    'showProductCheckedUser',
                    I18n.t('BEE805' /* Conferente */),
                  ),
                  formContext.createToggleBox(
                    showProductCustomerProductCode,
                    'showProductCustomerProductCode',
                    I18n.t('BEE2112' /* Produto Cliente */),
                  ),
                ])}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={this.resetLayout}
            >
              {I18n.t('BEE4443' /* Restaurar padrão */)}
            </button>
            <div>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-white p-5 m-5"
                onClick={this.closePageLayoutModal}
              >
                {I18n.t('BEE99' /* Cancelar */)}
              </OneClickButton>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={this.updatePageLayoutArray}
              >
                {I18n.t('BEE139' /* Atualizar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  };

  resetLayout = () => {
    this.setState({
      showLoadNumber: true,
      showTotalWeight: true,
      showCustomerOrderCode: true,
      showCustomer: true,
      showOrderType: true,
      showDeposit: true,
      showInvoiceNumber: true,
      showStatus: true,
      showUrgent: true,
      showPriority: true,
      showCarrier: true,
      showCity: true,
      showDeliveryDate: true,
      showCreatedAt: true,
      showDockControl: true,
      showWaybillNumber: true,
      showRestrictionPicking: true,
      showUserReleasePickingRestriction: true,
      showReleasePickingRestriction: true,
      showWithdrawalUser: true,
      showWithdrawalAt: true,
      showWithdrawalUserDocument: true,
      showWithdrawnNote: true,
      showProductDescription: true,
      showProductStatus: true,
      showProductQuantity: true,
      showProductCrossDockingQuantity: true,
      showProductMandatoryQuantity: true,
      showProductControlExpirationDate: true,
      showProductStockControlType: true,
      showProductAllocatedQuantity: true,
      showProductPickedQuantity: true,
      showProductPickedAt: true,
      showProductPickedUser: true,
      showProductCheckedQuantity: true,
      showProductCheckedAt: true,
      showProductCheckedUser: true,
      showProductCustomerProductCode: true,
      showProductComplementCode: true,
    });
  };

  modifyUrgency = async (docUrgent) => {
    const { outboundOrderUrgent } = this.state;

    if (outboundOrderUrgent) {
      try {
        const result = await this.props.toggleOrderPriority(outboundOrderUrgent, docUrgent);

        if (result && result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE1363' /* Monitor de Expedição */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE1363' /* Monitor de Expedição */),
            (docUrgent)
              ? I18n.t('BEE2635' /* Documento alterado para Urgente com sucesso! */)
              : I18n.t('BEE2636' /* Urgencia removida com sucesso! */),
            'top-right',
          );

          this.getOutboundOrders();
        }
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;

        if (error && error.message) {
          const messageError = (error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;
          addNotification('danger', I18n.t('BEE1363' /* Monitor de Expedição */), messageError, 'top-right');
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1363' /* Monitor de Expedição */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        }
      }
    }

    this.closeUrgentModal();
  };

  syncPickingConfirmation = async () => {
    try {
      this.setState({ showSyncPickingConfirmationModal: false });
      const { selectedOutboundOrder } = this.state;
      const result = await this.props.syncPickingConfirmationErp(selectedOutboundOrder.id);
      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE4570' /* Erro ao liberar faturamento */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE4574' /* Faturamento liberado com sucesso! */),
          'top-right',
        );

        this.getOutboundOrders();
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE1087' /* Documentos de Saída */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE1960' /* Erro ao gravar os dados */),
          'top-right',
        );
      }
    }
  };

  createTextArea = (value, attr, label, placeholder, rows, required, disabled) => (
    <div className="form-group p-2 mt-4">
      <label htmlFor={label}>{label}</label>
      <div className="col">
        <textarea
          className="form-control"
          rows={rows}
          value={value || ''}
          placeholder={disabled ? '' : placeholder}
          required={required}
          disabled={disabled}
          onChange={(e) => this.setValue(attr, e.target.value)}
        />
      </div>
    </div>
  );

  getOutboundOrderProducts = async () => {
    const { selectedOutboundOrder } = this.state;
    try {
      await this.props.getOutboundOrderProducts(selectedOutboundOrder.id);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification('danger', I18n.t('BEE1087' /* Documentos de Saída */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  getOutboundOrders = async () => {
    const { startDate, endDate, selectedOutboundOrder } = this.state;

    await this.props.getOutboundOrderListJustDocument(startDate, endDate);

    const orderList = this.props.outboundOrdersList;

    const existOrder = (orderList && orderList.length && Object.keys(selectedOutboundOrder).length)
      ? (orderList.find((element) => (element.id === selectedOutboundOrder.id)))
      : {};

    await this.setState({
      selectedOutboundOrder: existOrder || {},
    });

    if (existOrder && Object.keys(existOrder).length) {
      await this.getOutboundOrderProducts();
    } else {
      await this.props.setOutboundOrdersProducts([]);
    }
  };

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (
          event.target.value === ''
          && (event.keyCode === 8 || event.which === 8)
        ) {
          onChange(event.target.value);
        }
      }}
    />
  );

  showColumn = (layout, fieldName) => {
    if (layout) {
      return layout[fieldName] || false;
    }
    return true;
  };

  showOutboundOrderDetail = (outboundOrder) => {
    const { isConsult = false } = this.props;
    this.props.history.push({
      pathname: (isConsult) ? ROUTES.CONSULT_OUTBOUND_ORDER_DETAIL : ROUTES.OUTBOUND_ORDER_DETAIL,
      state: {
        outboundOrder: outboundOrder.original,
      },
    });
  };

  showCancelOrder = () => {
    this.setState({
      showCancelModal: true,
      cancelType: 'order',
    });
  };

  showSyncPickingConfirmation = (selectedOutboundOrder) => {
    this.setState({ showSyncPickingConfirmationModal: true, selectedOutboundOrder });
  };

  showDeallocateOrder = () => {
    this.setState({
      showDeallocateModal: true,
      deallocateType: 'order',
    });
  };

  showCancelProduct = async (outboundProduct) => {
    this.setState({
      selectedOutboundProduct: outboundProduct,
      selectedCancelOriginIds: [],
      cancelOrigins: [],
      cancelOriginChecked: {},
      cancelOriginTotalSelected: 0,
      showOriginSelectionModal: false,
      showCancelProductModal: false,
    });

    try {
      const result = await this.props.previewCancelOutboundProduct(
        outboundProduct.outboundOrderId,
        outboundProduct.id,
      );

      if (result && result.success === false) {
        const message = result.error && result.error.message
          ? result.error.message
          : I18n.t('BEE2952' /* Erro ao cancelar Produto */);
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          message,
          'top-right',
        );
        return;
      }

      if (result && result.requiresOriginSelection) {
        this.setState({
          showOriginSelectionModal: true,
          cancelOrigins: result.origins || [],
          cancelType: 'product',
        });
        return;
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;
      addNotification(
        'danger',
        I18n.t('BEE1087' /* Documentos de Saída */),
        messageError || I18n.t('BEE2954' /* Não foi possível cancelar o Produto */),
        'top-right',
      );
      return;
    }

    this.setState({
      showCancelProductModal: true,
      cancelType: 'product',
    });
  };

  toggleCancelOrigin = (origin) => {
    const { cancelOrigins } = this.state;
    const checked = { ...this.state.cancelOriginChecked };
    checked[origin.id] = !checked[origin.id];

    const selectedCancelOriginIds = [];
    let cancelOriginTotalSelected = 0;
    for (let index = 0; index < cancelOrigins.length; index += 1) {
      const item = cancelOrigins[index];
      if (checked[item.id]) {
        selectedCancelOriginIds.push(item.id);
        cancelOriginTotalSelected += parseFloat(item.quantity || 0);
      }
    }

    this.setState({
      cancelOriginChecked: checked,
      selectedCancelOriginIds,
      cancelOriginTotalSelected,
    });
  };

  closeOriginSelectionModal = () => {
    this.setState({
      showOriginSelectionModal: false,
      selectedCancelOriginIds: [],
      cancelOrigins: [],
      cancelOriginChecked: {},
      cancelOriginTotalSelected: 0,
      cancelType: '',
    });
  };

  confirmOriginSelection = () => {
    const { selectedCancelOriginIds } = this.state;
    if (!selectedCancelOriginIds.length) {
      addNotification(
        'warning',
        I18n.t('BEE1087' /* Documentos de Saída */),
        I18n.t('BEE4892' /* Selecione o documento de origem para cancelar o saldo */),
        'top-right',
      );
      return;
    }

    this.setState({
      showOriginSelectionModal: false,
      showUserModal: true,
      cancelType: 'product',
    });
  };

  showDeallocateProduct = (outboundProduct) => {
    this.setState({
      showDeallocateProductModal: true,
      deallocateType: 'product',
      selectedOutboundProduct: outboundProduct,
    });
  };

  showPrintFractionalPackagingLabel = (outboundOrderId = false, outboundOrderProductId = false) => {
    this.setState({
      showPrintFractionalPackagingLabelModal: true,
      selectedOutboundOrder: outboundOrderId,
      selectedOutboundProduct: outboundOrderProductId,
    });
  };

  onGenerateSalesOrderPDF = async (outboundOrder) => {
    const { location } = this.props;

    const outboundOrderId = outboundOrder.id;

    await this.props.generateReport(
      I18n.t('BEE4551' /* Pedido de Vendas */),
      'pdf',
      location.pathname,
      [{}],
      { id: outboundOrderId },
    );
  };

  showCancelCrossdockingProduct = (outboundProduct) => {
    this.setState({
      showCancelCrossdockingProductModal: true,
      cancelType: 'crossdocking',
      selectedOutboundProduct: outboundProduct,
    });
  };

  cancelOrder = async () => {
    try {
      const { selectedOutboundOrder } = this.state;

      const result = await this.props.cancelOutboundOrder(selectedOutboundOrder.id);
      if (result && result.success === false) {
        const message = result.error && result.error.message
          ? result.error.message
          : I18n.t('BEE2948' /* Erro ao cancelar Documento de Saída */);
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          message,
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE2949' /* Documento cancelado com sucesso! */),
          'top-right',
        );
        this.getOutboundOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE2950' /* Não foi possível cancelar o Documento de Saída. */),
          'top-right',
        );
      }
    }

    this.setState({
      cancelType: '',
      deallocateType: '',
    });
  };

  deallocateOrder = async () => {
    try {
      const { selectedOutboundOrder } = this.state;

      const result = await this.props.deallocateOutboundOrder(selectedOutboundOrder.id);

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE3284' /* Erro ao desalocar documento de saída. */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE3285' /* Documento desalocado com sucesso! */),
          'top-right',
        );
        this.getOutboundOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE3286' /* Não foi possível desalocar o Documento de Saída. */),
          'top-right',
        );
      }
    }

    this.setState({
      cancelType: '',
      deallocateType: '',
    });
  };

  cancelProduct = async () => {
    try {
      const { selectedOutboundProduct } = this.state;

      const result = await this.props.cancelOutboundProduct(
        selectedOutboundProduct.outboundOrderId,
        selectedOutboundProduct.id,
        this.state.selectedCancelOriginIds,
      );

      if (result && result.requiresOriginSelection) {
        this.setState({
          showOriginSelectionModal: true,
          cancelOrigins: result.origins || [],
          selectedCancelOriginIds: [],
          cancelOriginChecked: {},
          cancelOriginTotalSelected: 0,
          cancelType: 'product',
        });
        return;
      }

      if (result && result.success === false) {
        const message = result.error && result.error.message
          ? result.error.message
          : I18n.t('BEE2952' /* Erro ao cancelar Produto */);
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          message,
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE2953' /* Produto cancelado com sucesso! */),
          'top-right',
        );

        this.getOutboundOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE2954' /* Não foi possível cancelar o Produto */),
          'top-right',
        );
      }
    }

    this.setState({
      cancelType: '',
      deallocateType: '',
      selectedCancelOriginIds: [],
      cancelOriginChecked: {},
      cancelOriginTotalSelected: 0,
      showOriginSelectionModal: false,
    });
  };

  deallocateProduct = async () => {
    try {
      const { selectedOutboundProduct } = this.state;

      const result = await this.props.deallocateOutboundProduct(
        selectedOutboundProduct.outboundOrderId,
        selectedOutboundProduct.id,
      );

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE3287' /* Erro ao desalocar produto */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE3288' /* Produto desalocado com sucesso! */),
          'top-right',
        );

        this.getOutboundOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE3289' /* Não foi possível desalocar o produto. */),
          'top-right',
        );
      }
    }

    this.setState({
      cancelType: '',
      deallocateType: '',
    });
  };

  cancelCrossdockingProduct = async () => {
    try {
      const { selectedOutboundProduct } = this.state;

      const result = await this.props.cancelCrossdockingProduct(
        selectedOutboundProduct.id,
      );

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE4379' /* Erro ao cancelar Cross-Docking. */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE4380' /* Cross-Docking cancelado com sucesso. */),
          'top-right',
        );

        this.getOutboundOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1087' /* Documentos de Saída */),
          I18n.t('BEE4381' /* Não foi possível cancelar o Cross-Docking. */),
          'top-right',
        );
      }
    }

    this.setState({
      cancelType: '',
      deallocateType: '',
    });
  };

  handleDateApplyEvent = async (event) => {
    const startDate = event[0];
    const endDate = event[1];

    await this.setState({
      startDate,
      endDate,
    });

    this.getOutboundOrders();
  };

  createWidgetStats = () => {
    const { outboundOrdersList = [] } = this.props;

    const stats1 = [
      {
        title: I18n.t('BEE2009' /* Alocação */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 1,
        ).length,
        color: 'yellow',
      }, {
        title: I18n.t('BEE1420' /* Corte de Cabos */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 2,
        ).length,
        color: 'dark',
      }, {
        title: I18n.t('BEE43' /* Separação */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 3 || order.status === 4,
        ).length,
        color: 'orange',
      }, {
        title: I18n.t('BEE37' /* Conferência */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 5,
        ).length,
        color: 'teal',
      }, {
        title: I18n.t('BEE199' /* Doca */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 6,
        ).length,
        color: 'aqua',
      },
    ];

    const stats2 = [
      {
        title: I18n.t('BEE4623' /* Faturamento */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 7 || order.status === 9,
        ).length,
        color: 'purple',
      }, {
        title: I18n.t('BEE44' /* Consolidação */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 8,
        ).length,
        color: 'green',
      }, {
        title: I18n.t('BEE1766' /* Finalizado */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 10,
        ).length,
        color: 'blue',
      }, {
        title: I18n.t('BEE176' /* Divergência */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 11,
        ).length,
        color: 'red',
      }, {
        title: I18n.t('BEE64' /* Cancelado */).toUpperCase(),
        quantity: outboundOrdersList.filter(
          (order) => order.status === 12 || order.status === 13,
        ).length,
        color: 'silver',
      },
    ];

    return (
      <>
        <div
          className="row row-space-10 m-b-15"
          style={{ justifyContent: 'space-between' }}
        >
          {stats1.map((stat, index) => (
            <div className="col-xl-2" key={index}>
              <div
                style={{ maxHeight: '100px' }}
                className={`widget widget-stats bg-${stat.color} m-b-15 p-b-0`}
              >
                <div className="stats-content text-center">
                  <div className="stats-title f-w-800" style={{ color: '#fff', fontSize: '14px' }}>{stat.title}</div>
                  <div className="stats-number f-s-30 mb-5">{stat.quantity}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div
          className="row row-space-10 m-b-15"
          style={{ justifyContent: 'space-between' }}
        >
          {stats2.map((stat, index) => (
            <div className="col-xl-2" key={index}>
              <div
                style={{ maxHeight: '100px' }}
                className={`widget widget-stats bg-${stat.color} m-b-15 p-b-0`}
              >
                <div className="stats-content text-center">
                  <div className="stats-title f-w-800" style={{ color: '#fff', fontSize: '14px' }}>{stat.title}</div>
                  <div className="stats-number f-s-30 mb-5">{stat.quantity}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  userConfirmation = async (confirm) => {
    const { cancelType, deallocateType } = this.state;

    this.setState({ showUserModal: false });
    if (confirm && cancelType === 'order') this.cancelOrder();
    if (confirm && cancelType === 'product') this.cancelProduct();
    if (confirm && cancelType === 'crossdocking') this.cancelCrossdockingProduct();
    if (confirm && deallocateType === 'order') this.deallocateOrder();
    if (confirm && deallocateType === 'product') this.deallocateProduct();
  };

  selectedProducts = async (selectedOutboundOrder) => {
    if (!this.state.selectedOutboundOrder || (selectedOutboundOrder && this.state.selectedOutboundOrder
      && this.state.selectedOutboundOrder.id !== selectedOutboundOrder.id)) {
      await this.setState({ selectedOutboundOrder: { ...selectedOutboundOrder } });
      await this.getOutboundOrderProducts();

      const result = await this.props.cutsMonitoList({
        filtersProduct: { outboundOrderId: { type: 'and', value: selectedOutboundOrder.id } },
      });

      const plans = (result && result.rows) ? result.rows : [];

      let cutList = [];
      for (const plan of plans) {
        const products = await cutsMonitoRequests.getCableCutProductList(plan.id);
        cutList = [...cutList, ...products];
      }

      this.setState({ hasCableCut: cutList.length > 0, cableCutList: cutList });
    }
  };

  showPreExpeditionModal = (selectedOutboundOrder) => {
    this.setState({
      showPreExpeditionModal: true,
      withdrawalUser: selectedOutboundOrder.withdrawalUser,
      withdrawalAt: selectedOutboundOrder.withdrawalAt
        ? moment(selectedOutboundOrder.withdrawalAt)
        : null,
      withdrawnUserDocument: selectedOutboundOrder.withdrawnUserDocument,
      withdrawnNote: selectedOutboundOrder.withdrawnNote,
      selectedOutboundOrder,
    });
  };

  closePreExpeditionModal = () => {
    this.setState({ showPreExpeditionModal: false });
  };

  confirmPreExpedition = async (outboundOrderId) => {
    const {
      withdrawalAt,
      withdrawalUser,
      withdrawnUserDocument,
      withdrawnNote,
    } = this.state;

    if (outboundOrderId) {
      try {
        const result = await this.props.confirmPreExpedition(
          outboundOrderId,
          withdrawalAt,
          withdrawalUser,
          withdrawnUserDocument,
          withdrawnNote,
        );

        if (result && result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE1087' /* Documentos de Saída */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE1087' /* Documentos de Saída */),
            I18n.t('BEE4581' /* Pré-Expedição salva com sucesso! */),
            'top-right',
          );

          this.getOutboundOrders();
        }
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;

        if (error && error.message) {
          const messageError = (error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;
          addNotification(
            'danger',
            I18n.t('BEE1087' /* Documentos de Saída */),
            messageError,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1087' /* Documentos de Saída */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        }
      }
    }

    this.closePreExpeditionModal();
  };

  render() {
    const { outboundOrdersList = [], outboundOrderProductsList = [], isConsult = false } = this.props;

    const {
      showCancelModal, showCancelProductModal, selectedOutboundOrder, defaultSorted,
      defaultSortedProducts, defaultSortedCableCut, showModalNote, note, showModalUrgent, showRemoveUrgent,
      showDeallocateModal, showDeallocateProductModal, showPrintFractionalPackagingLabelModal,
      showCancelCrossdockingProductModal, showSyncPickingConfirmationModal, showPreExpeditionModal,
      withdrawalUser, withdrawalAt, withdrawnUserDocument, withdrawnNote,
      hasCableCut,
    } = this.state;

    return (
      <>
        <div>
          <div className="d-flex align-items-center">
            <ol className="breadcrumb float-xl-left">
              <li className="breadcrumb-item">
                <i className="fas fa-home fa-fw m-t-10 m-r-5" />
                {' '}
                {I18n.t('BEE12' /* Início */)}
              </li>
              <li className="breadcrumb-item">
                {(isConsult) ? I18n.t('BEE33' /* Consultas */) : I18n.t('BEE1400' /* Movimentação */)}
              </li>
              <li className="breadcrumb-item">{I18n.t('BEE41' /* Expedição */)}</li>
              <li className="breadcrumb-item active">{I18n.t('BEE1087' /* Documentos de Saída */)}</li>
            </ol>
          </div>
          <div className="d-flex align-items-center mb-md-3 mb-2">
            <h1 className="page-header mb-0">
              {I18n.t('BEE1087' /* Documentos de Saída */)}
            </h1>
            <WikiHelp wikiPath={isConsult
              ? ROUTES.CONSULT_OUTBOUND_ORDER_HELP : ROUTES.OUTBOUND_ORDER_LIST_HELP}
            />
          </div>
          {!isConsult && this.createWidgetStats()}
          <Table
            downloadCSV
            panelHeaderProps={{
              onClickReload: this.getOutboundOrders,
            }}
            datePicker={{
              handleDateApplyEvent: this.handleDateApplyEvent,
            }}
            filterable
            data={outboundOrdersList}
            columns={this.state.tableColumns}
            expander
            defaultPageSize={5}
            defaultSorted={defaultSorted}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: () => {
                    this.selectedProducts(rowInfo.original);
                  },
                  style: {
                    background: selectedOutboundOrder && rowInfo.original.id === selectedOutboundOrder.id
                      ? 'silver'
                      : 'white',
                    cursor: 'pointer',
                  },
                };
              }
              return {};
            }}
            actionButtons={(
              <div className="ml-auto mt-1">
                {!Permissions.checkPermission(ROUTES.P_OUTBOUND_ORDER_MANAGE_FIELDS) && (
                  <button
                    type="button"
                    className="btn btn-primary p-5"
                    onClick={() => this.showPageLayoutModal()}
                  >
                    {I18n.t('BEE4439' /* Gerenciar Colunas */)}
                  </button>
                )}
              </div>
            )}
          />
        </div>
        <Table
          downloadCSV
          panelHeaderProps={{
            children: I18n.t('BEE27' /* Produtos */).toUpperCase(),
          }}
          filterable
          data={outboundOrderProductsList}
          columns={this.state.productTableColumns}
          expander
          defaultPageSize={10}
          pageSizeOptions={[5, 10, 15]}
          defaultSorted={defaultSortedProducts}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {hasCableCut && (
          <Table
            downloadCSV
            panelHeaderProps={{
              children: I18n.t('BEE4620' /* Produtos de Corte */).toUpperCase(),
            }}
            filterable
            data={this.state.cableCutList || []}
            columns={this.state.cableCutProductTableColumns}
            expander
            defaultPageSize={10}
            pageSizeOptions={[5, 10, 15]}
            defaultSorted={defaultSortedCableCut}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
          />
        )}
        <UserConfirmationModal
          openModal={this.state.showUserModal}
          confirm={(confirm) => this.userConfirmation(confirm)}
        />
        {(showCancelModal
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE2943' /* Cancelar Documento */)}
              onConfirm={() => this.setState({ showUserModal: true, showCancelModal: false, cancelType: 'order' })}
              onCancel={() => this.setState({ showCancelModal: false, cancelType: '' })}
            >
              {I18n.t('BEE2946' /* Documento de saída será cancelado! Deseja continuar? */)}
            </SweetAlert>
          )
        )}
        {(showDeallocateModal && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE3279' /* Desalocar documento */)}
            onConfirm={() => this.setState({
              showUserModal: true,
              showDeallocateModal: false,
              deallocateType: 'order',
            })}
            onCancel={() => this.setState({ showDeallocateModal: false, deallocateType: '' })}
          >
            {I18n.t('BEE3283' /* O documento de saída será desalocado! Deseja continuar? */)}
          </SweetAlert>
        )
        )}
        {(showCancelProductModal
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE2944' /* Cancelar Produto */)}
              onConfirm={() => this.setState({
                showUserModal: true,
                showCancelProductModal: false,
                cancelType: 'product',
              })}
              onCancel={() => this.setState({ showCancelProductModal: false, cancelType: '' })}
            >
              {I18n.t('BEE2945' /* Produto será cancelado! Deseja continuar? */)}
            </SweetAlert>
          )
        )}
        <Modal
          size="lg"
          isOpen={this.state.showOriginSelectionModal}
          toggle={() => this.closeOriginSelectionModal()}
        >
          <ModalHeader toggle={() => this.closeOriginSelectionModal()}>
            <div style={{ display: 'flex' }}>
              <p className="col-md-12">
                <strong>
                  {this.state.selectedOutboundProduct
                    && (this.state.selectedOutboundProduct.productName
                      ? `${this.state.selectedOutboundProduct.productCode} - ${this.state.selectedOutboundProduct.productName}`
                      : this.state.selectedOutboundProduct.productCode)}
                </strong>
              </p>
            </div>
            <div style={{ display: 'flex' }}>
              <p className="col-md-12">
                <strong>
                  {`${I18n.t('BEE441' /* Quantidade */)}: `}
                </strong>
                {FormatHelpers.formatNumber(
                  this.state.selectedOutboundProduct
                    && (parseFloat(this.state.selectedOutboundProduct.quantity) || 0),
                  4,
                  false,
                )}
              </p>
            </div>
            <div style={{ display: 'flex' }}>
              <p className="col-md-12">
                <strong>
                  {`${I18n.t('BEE2008' /* Quantidade Alocada */)}: `}
                </strong>
                {FormatHelpers.formatNumber(
                  this.state.selectedOutboundProduct
                    && (parseFloat(this.state.selectedOutboundProduct.allocatedQuantity) || 0),
                  4,
                  false,
                )}
              </p>
            </div>
          </ModalHeader>
          <ModalBody>
            <Table
              panelHeaderProps={{
                noButton: true,
                children: I18n.t('BEE4897' /* Selecionar Documento para Cancelamento */).toUpperCase(),
              }}
              filterable
              data={this.state.cancelOrigins || []}
              columns={[{
                Header: I18n.t('BEE436' /* Selecionar */),
                accessor: 'selected',
                style: { overflow: 'visible', alignSelf: 'center' },
                filterable: false,
                sortable: false,
                width: 100,
                Cell: (row) => (
                  <div style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={!!this.state.cancelOriginChecked[row.original.id]}
                      onChange={() => this.toggleCancelOrigin(row.original)}
                    />
                  </div>
                ),
              }, {
                Header: I18n.t('BEE443' /* Documento */),
                accessor: 'orderNumber',
                style: { alignSelf: 'center', textAlign: 'center' },
                minWidth: 150,
              }, {
                Header: I18n.t('BEE50' /* Cliente */),
                accessor: 'customerCode',
                style: { alignSelf: 'center', textAlign: 'center' },
                minWidth: 120,
              }, {
                Header: I18n.t('BEE441' /* Quantidade */),
                accessor: 'quantity',
                style: { alignSelf: 'center', textAlign: 'center' },
                minWidth: 120,
                Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
              }]}
              pageSizeOptions={[5, 10]}
              defaultPageSize={5}
              defaultSorted={[{ id: 'orderNumber', desc: false }]}
              defaultFilterMethod={(filter, row) => {
                const input = _.lowerCase(filter.value);
                const value = _.lowerCase(row[filter.id]);
                if (_.includes(value, input)) {
                  return true;
                }
              }}
            />
            <div className="row">
              <label htmlFor="cancelOriginTotalSelected" className="col-sm-3 col-form-label f-s-16 f-w-700 m-l-5">
                {I18n.t('BEE3300' /* Total Selecionado */)}
                :
                {' '}
              </label>
              <div className="col-sm-3">
                <input
                  id="cancelOriginTotalSelected"
                  className="form-control text-center f-s-14"
                  type="text"
                  value={FormatHelpers.formatNumber(this.state.cancelOriginTotalSelected || 0, 4)}
                  readOnly
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <OneClickButton
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={() => this.confirmOriginSelection()}
              disabled={!this.state.selectedCancelOriginIds.length}
            >
              {I18n.t('BEE1849' /* continuar */)}
            </OneClickButton>
          </ModalFooter>
        </Modal>
        {(showDeallocateProductModal && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE3281' /* Desalocar o produto */)}
            onConfirm={() => this.setState({
              showUserModal: true,
              showDeallocateProductModal: false,
              deallocateType: 'product',
            })}
            onCancel={() => this.setState({ showDeallocateProductModal: false, deallocateType: '' })}
          >
            {I18n.t('BEE3280' /* O produto será desalocado! Deseja continuar? */)}
          </SweetAlert>
        )
        )}
        {(showModalNote
          && (
            <SweetAlert
              confirmBtnText={I18n.t('BEE1484' /* OK */)}
              confirmBtnBsStyle="primary"
              title={I18n.t('BEE135' /* Observação */)}
              onConfirm={() => this.setState({
                showModalNote: false,
                note: '',
              })}
              btnSize="sm"
            >
              {this.createTextArea(
                note,
                'note',
                I18n.t('BEE135' /* Observação */),
                '',
                10,
                false,
                true,
              )}
            </SweetAlert>
          ))}
        {(showModalUrgent
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.modifyUrgency(true)}
              onCancel={() => this.closeUrgentModal()}
            >
              {I18n.t('BEE2633')}
              {/* O Documento de Saída vai ser alterado para Urgente e terá prioridade no processo de Separação */}
            </SweetAlert>
          )
        )}
        {showRemoveUrgent && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE101' /* Você tem certeza? */)}
            onConfirm={() => this.modifyUrgency(false)}
            onCancel={() => this.closeUrgentModal()}
          >
            {I18n.t('BEE2634')}
            {/* O Documento de Saída terá sua Urgência removida e perderá sua prioridade no processo de Separação */}
          </SweetAlert>
        )}
        {(showPrintFractionalPackagingLabelModal && (
          <PrintFractionalPackagingLabel
            modalMode
            openChangeModal={showPrintFractionalPackagingLabelModal}
            closeModalPrintFractionalPackagingLabel={() => {
              this.setState({ showPrintFractionalPackagingLabelModal: false });
            }}
            outboundOrder={this.state.selectedOutboundOrder}
            outboundOrderProduct={this.state.selectedOutboundProduct}
            showAllColumnsDatatable={!!this.state.selectedOutboundOrder}
          />
        )
        )}
        {(showCancelCrossdockingProductModal
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE4378' /* Cancelar Cross-Docking */)}
              onConfirm={() => this.setState({
                showUserModal: true,
                showCancelCrossdockingProductModal: false,
                cancelType: 'crossdocking',
              })}
              onCancel={() => this.setState({ showCancelCrossdockingProductModal: false, cancelType: '' })}
            >
              {I18n.t('BEE4382' /* O Cross-Docking será cancelado! Deseja continuar? */)}
            </SweetAlert>
          )
        )}
        {(showSyncPickingConfirmationModal
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE4569' /* Liberar o faturamento */)}
              onConfirm={this.syncPickingConfirmation}
              onCancel={() => this.setState({ showSyncPickingConfirmationModal: false })}
            >
              {I18n.t('BEE4568' /* Deseja liberar o faturamento deste documento? */)}
            </SweetAlert>
          )
        )}
        {this.createPageLayoutModal()}
        <Modal isOpen={showPreExpeditionModal} toggle={this.closePreExpeditionModal}>
          <ModalHeader toggle={this.closePreExpeditionModal}>
            {I18n.t('BEE4579' /* Confirmar Pré-Expedição */)}
          </ModalHeader>
          <ModalBody>
            <Form
              noHeader
              headerProps={{
                className: 'w-100',
              }}
              setValue={this.setValue}
              footerContent={(
                <div className="text-center p-3 m-0">
                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      type="button"
                      className="btn btn-120 btn-white p-5 mx-2 mb-0"
                      onClick={() => this.closePreExpeditionModal()}
                    >
                      {I18n.t('BEE99' /* Cancelar */)}
                    </button>
                    <button
                      type="button"
                      className="btn btn-120 btn-primary p-5 mx-2 mb-0"
                      onClick={() => this.confirmPreExpedition(selectedOutboundOrder.id)}
                    >
                      {I18n.t('BEE1849' /* Continuar */)}
                    </button>
                  </div>
                </div>
              )}
              inputs={(formContext) => ([
                formContext.createInput(
                  withdrawalUser,
                  'withdrawalUser',
                  I18n.t('BEE4575' /* Nome do motorista */),
                  '',
                  'text',
                  true,
                  undefined,
                  undefined,
                  6,
                  this.goToElement,
                  1,
                  100,
                  ['form-group row m-b-15', 'col-form-label col-md-4'],
                ),
                (
                  <div key="withdrawalAt" className="form-group row m-b-15">
                    <label className="col-form-label col-md-4">
                      {I18n.t('BEE4576' /* Data e Hora de Saída Física */)}
                    </label>
                    <div className="col-md-6">
                      <DateTime
                        inputProps={{ className: 'form-control', placeholder: '' }}
                        value={withdrawalAt}
                        onChange={(dt) => {
                          this.setValue('withdrawalAt', (dt && dt.format) ? dt : null);
                        }}
                        closeOnSelect
                      />
                    </div>
                  </div>
                ),
                formContext.createInput(
                  withdrawnUserDocument,
                  'withdrawnUserDocument',
                  I18n.t('BEE4577' /* Documento do Motorista */),
                  '',
                  'text',
                  false,
                  undefined,
                  undefined,
                  6,
                  this.goToElement,
                  2,
                  100,
                  ['form-group row m-b-15', 'col-form-label col-md-4'],
                ),
                formContext.createTextArea(
                  withdrawnNote,
                  'withdrawnNote',
                  I18n.t('BEE135' /* Observação */),
                  '',
                  5,
                  undefined,
                  undefined,
                  undefined,
                  ['form-group row m-b-15', 'col-form-label col-md-4', 'col-md-6'],
                  4,
                  undefined,
                  100,
                ),
              ])}
            />
          </ModalBody>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  outboundOrdersList: state.outboundOrders && state.outboundOrders.outboundOrdersListJustDocument,
  outboundOrderProductsList: state.outboundOrders && state.outboundOrders.outboundOrderProductsList,
  userLogged: state.app.userLogged && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getOutboundOrderListJustDocument: (
    startDate,
    endDate,
  ) => dispatch(getOutboundOrderListJustDocument(startDate, endDate)),
  getOutboundOrderProducts: (outboundOrderId) => dispatch(getOutboundOrderProducts(outboundOrderId)),
  setOutboundOrdersProducts: (outboundOrderProductsList) => dispatch(setOutboundOrdersProducts(
    outboundOrderProductsList,
  )),
  cancelOutboundOrder: (outboundOrderId) => dispatch(cancelOutboundOrder(outboundOrderId)),
  previewCancelOutboundProduct: (
    outboundOrderId,
    outboundProductId,
  ) => dispatch(previewCancelOutboundProduct(outboundOrderId, outboundProductId)),
  cancelOutboundProduct: (
    outboundOrderId,
    outboundProductId,
    outboundOrderLoadSimplifiedIds,
  ) => dispatch(cancelOutboundProduct(
    outboundOrderId,
    outboundProductId,
    outboundOrderLoadSimplifiedIds,
  )),
  cancelCrossdockingProduct: (
    outboundProductId,
  ) => dispatch(cancelCrossdockingProduct(outboundProductId)),
  toggleOrderPriority: (outboundOrderId, docUrgent) => dispatch(toggleOrderPriority(outboundOrderId, docUrgent)),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  deallocateOutboundOrder: (outboundOrderId) => dispatch(deallocateOutboundOrder(outboundOrderId)),
  deallocateOutboundProduct: (
    outboundOrderId,
    outboundProductId,
  ) => dispatch(deallocateOutboundProduct(outboundOrderId, outboundProductId)),
  updatePageLayout: (pageLayout) => dispatch(updatePageLayout(pageLayout)),
  getPageLayout: (pageLayout) => dispatch(getPageLayout(pageLayout)),
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters, true)),
  syncPickingConfirmationErp: (
    outboundOrderId,
  ) => dispatch(syncPickingConfirmationErp(outboundOrderId)),
  confirmPreExpedition: (
    outboundOrderId,
    withdrawalAt,
    withdrawalUser,
    withdrawnUserDocument,
    withdrawnNote,
  ) => dispatch(
    confirmPreExpedition(
      outboundOrderId,
      withdrawalAt,
      withdrawalUser,
      withdrawnUserDocument,
      withdrawnNote,
    ),
  ),
  cutsMonitoList: (tableParams) => dispatch(cutsMonitoList(tableParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundOrderList));
